export const LOGO_IMAGE = '/images/notchup-logo.png';
export const LOGO_IMAGE_MOBILE = '/images/notchup-logo.png';
export const NEW_AVATAR_IMAGE = '/images/new-avatar.svg';
export const UPGRADE_BANNER_IMAGE = '/images/upgrade-banner.svg';

export const API_URL = process.env.NEXT_PUBLIC_API_URL;
/** Override for workflows list GET (e.g. apitest). Defaults to `${API_URL}/workflows`. */
export const WORKFLOWS_LIST_API_URL =
  process.env.NEXT_PUBLIC_WORKFLOWS_API_URL ?? `${API_URL}/workflows`;
export const WS_URL = process.env.NEXT_PUBLIC_WS_URL || 'wss://apiapp.notchup.com/ws/chat';
/** Offered with the session JWT so the server can accept without echoing the token. */
export const WS_CHAT_PROTOCOL = 'notchup-chat';
/** Prefix for the WebSocket subprotocol that carries the session JWT (`bearer.<jwt>`). */
export const WS_CHAT_BEARER_PREFIX = 'bearer.';
export const GOOGLE_PICKER_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_PICKER_API_KEY;
export const GOOGLE_PICKER_APP_ID = process.env.NEXT_PUBLIC_GOOGLE_PICKER_APP_ID;

// API endpoints
export const AUTH = '/auth';
export const SIGN_UP_API = '/signup';
export const LOGIN_API = '/login';
export const LOGOUT_API = '/logout';
export const RESEND_OTP_API = '/resend-otp';
export const OTP_LENGTH = 6;
export const OTP_EXPIRY_MINUTES = 30;
export const TOO_MANY_ATTEMPTS_MESSAGE = 'Too many attempts, try again later';
/** Shown when POST /auth/logout cannot revoke the session (503 or network). */
export const LOGOUT_FAILED_MESSAGE = 'Could not log out. Please try again.';
/** Session cookie lifetime; must not exceed the backend JWT cap of 24 hours. */
export const TOKEN_COOKIE_MAX_AGE_SECONDS = 24 * 60 * 60;
export const TALENTS = '/talents';
export const CV_API = '/cv';
export const VOICE_API = '/voice';
export const SAVE_VOICE_API = '/agent/clone/save-voice';
export const CLONE_ACTIVITY_API = '/agent/clone/activity';
export const RATE_TOP_QUERY_API = '/agent/rate-top-query';
export const END_CONVERSATION_API = '/agent/conversation/end';
export const ADDITIONAL_FILES_API = '/agent/save-document';
export const FORGET_DOCUMENT_API = '/agent/forget-document';
export const ADDITIONAL_LINKS_API = '/agent/get-info-from-url';
export const FORGET_URL_API = '/agent/forget-url';
export const TOOL_SERVERS_API = '/tool-servers';
export const MCP_API_KEY_PATH = '/mcp/api-key';
export const AGENT_TOOL_SERVER_SYNC_API = '/agent/sync';
export const LLM_OPTIONS_API = '/users/llm-options';
export const LLM_PREFERENCES_API = '/users/llm-preferences';
export const REFINE_AVATAR_API = '/users/refine-avatar';
export const CONNECTORS_API = '/agent/connectors';
export const CONNECTOR_AUTHORIZE_API = '/agent/authorize';
export const GENERATE_CV_API = '/generate-cv';
export const USERS = '/users';
export const PROFILE_PHOTO_API = '/profile-photo';
export const CLONE_PROFILE_PATH = '/user';
export const LEGACY_CLONE_PROFILE_PATH = '/talent';

// LinkedIn OAuth
export const LINKEDIN_CLIENT_ID = process.env.NEXT_PUBLIC_LINKEDIN_CLIENT_ID;
export const LINKEDIN_AUTH_REDIRECT_URI = `${process.env.NEXT_PUBLIC_BASE_URL}/auth/login/linked-in`;
export const LINKEDIN_OAUTH_REDIRECT_URI = `${process.env.NEXT_PUBLIC_BASE_URL}/auth/oauth-callback?provider=linkedin`;
export const LINKEDIN_AUTH_API = '/login/linked-in';

// GitHub OAuth
export const GITHUB_CLIENT_ID = process.env.NEXT_PUBLIC_GITHUB_CLIENT_ID;
export const GITHUB_AUTH_REDIRECT_URI = `${process.env.NEXT_PUBLIC_BASE_URL}/auth/login/github`;
export const GITHUB_OAUTH_REDIRECT_URI = `${process.env.NEXT_PUBLIC_BASE_URL}/auth/oauth-callback?provider=github`;
export const GITHUB_AUTH_API = '/login/github';

// Social Media URLs (from original constants)
export const NOTCHUP_DISCORD_URL = 'https://discord.com/invite/m4e6BbB9ZA';
export const NOTCHUP_TWITTER_URL = 'https://twitter.com/notchupteam';
export const NOTCHUP_LINKEDIN_URL = 'https://www.linkedin.com/company/codemonk-ai/';
export const NOTCHUP_TELEGRAM_URL = 'https://t.me/codemonk_ai';
export const NOTCHUP_GITHUB_URL = 'https://github.com/CodeMonk-ai';
export const NOTCHUP_DRIBBBLE_URL = 'https://dribbble.com/CodeMonk_AI/about/';
export const NOTCHUP_FACEBOOK_URL = 'https://www.facebook.com/notchup.fow/';
export const NOTCHUP_INSTAGRAM_URL = 'https://www.instagram.com/notchupteam';

// Footer Policy URLs (from original constants)
export const TERMS_CONDITION_URL = 'https://xditto.com/terms';
export const PRIVACY_POLICY_URL = 'https://xditto.com/privacy-policy';
export const COOKIE_POLICY_URL = 'https://xditto.com/cookie-policy';
export const ACCEPTABLE_POLICY_URL = 'https://xditto.com/acceptable-use-policy';

// Help Centre
export const HELP_CENTRE_URL = 'https://help.xditto.com/en';
export const CREATE_CLONE_LEARN_MORE_URL =
  'https://help.xditto.com/en/collections/19758487-how-to-use-my-ai-clone';
export const BUILD_CAPABILITY_HELP_URL =
  'https://help.xditto.com/en/articles/17127522-how-do-you-teach-your-clone-a-new-skill';
export const BUILD_CLONE_HELP_URL =
  'https://help.xditto.com/en/articles/17127511-how-do-you-create-your-ai-clone-in-3-simple-steps';

// Help Us Improve
// export const TYPEFORM_URL = 'https://form.typeform.com/to/MNIinYUh';
export const TYPEFORM_URL = 'https://form.typeform.com/to/UvuFkjeX';
export const HYPERLINK_ICON = '/images/hyperlink.svg';

// Auth Carousel Slide Images (local WebP; keep under ~50KB each for LCP)
export const AUTH_SLIDE_IMAGES = [
  '/images/auth/screen1.webp',
  '/images/auth/screen2.webp',
  '/images/auth/screen3.webp',
] as const;

/** Empty-capabilities intro on the dashboard (GCS; do not bundle in the repo). */
export const CAPABILITIES_INTRO_VIDEO_URL =
  'https://storage.googleapis.com/dev-codemonk-static-content/public/build-capability.mp4';

/** Create-clone welcome modal video (GCS; do not bundle in the repo). */
export const CREATE_CLONE_WELCOME_VIDEO_URL =
  'https://storage.googleapis.com/dev-codemonk-static-content/public/how-to-create-clone.mp4';

/** Poster / end-frame thumbnail for the create-clone welcome video. */
export const CREATE_CLONE_THUMBNAIL_URL = '/images/create-clone-thumbnail.png';

/** Dashboard header intro video (YouTube). */
export const DASHBOARD_INTRO_VIDEO_URL = 'https://youtu.be/SV1WC6LzmfM';

/** Connectors settings header intro video (YouTube). */
export const CONNECTORS_INTRO_VIDEO_URL = 'https://youtu.be/Uasq7ihOW1Q';
/** Create-clone bottom-right info icon video (YouTube). */
export const CREATE_CLONE_INTRO_VIDEO_URL = 'https://youtu.be/jZU37n93O1E';

// Career Roadmap Icons
export const ICONS = {
  LOCATION: '/images/location.svg',
  PROFILE: '/images/profile.svg',
  WORK_SMALL: '/images/work-small.svg',
  SKILLS: '/images/skills.svg',
  FLAG: '/images/flag.svg',
  PLUS_CIRCLE: '/images/plus-circle.svg',
  MINUS_CIRCLE: '/images/minus-circle.svg',
  COURSES: '/images/courses.svg',
  ARROW: '/images/arrow.svg',
  COPY: '/images/copy.svg',
  CLOSE: '/images/close.svg',
  WARNING: '/images/warning.svg',
  SUCCESS: '/images/success.svg',
  FAILURE: '/images/failure.svg',
  TICK: '/images/tick.svg',
  SEARCH: '/images/search.svg',
  VIDEO: '/images/video.svg',
  TEAM: '/images/team.svg',
  PAY: '/images/pay.svg',
  URL: '/images/url.svg',
  PRO_BADGE: '/images/pro-badge.svg',
  REFER: '/images/refer.svg',
  VIEW_CLONE: '/images/view-clone.svg',
  EYE_ICON: '/images/eye-icon.svg',
  PLAY: '/images/play-icon.svg',
  PLAY_WHITE: '/images/play-white.svg',
  PLAY_OUTLINE: '/images/play-outline.svg',
  PAUSE: '/images/pause-icon.svg',
  DELETE: '/images/delete.svg',
  CLOUD_UPLOAD: '/images/cloud-upload.svg',
  PAPER: '/images/paper.svg',
  RELOAD: '/images/reload.svg',
  TRASH: '/images/trash.svg',
  EDIT: '/images/edit.svg',
  GOOGLE_DRIVE: '/images/google-drive.svg',
  DROPBOX: '/images/dropbox.svg',
  ONEDRIVE: '/images/onedrive.svg',
  DISCONNECT: '/images/disconnect.svg',
  KNOWLEDGE_DRIVE_UPDATE: '/images/update.svg',
  ARCHIVE: '/images/archive.svg',
  INFO: '/images/info.svg',
  INFORMATION: '/images/information.svg',
} as const;

// AI Clone Voices
export const AI_VOICES = [
  {
    gender: 'female',
    url: 'https://storage.googleapis.com/dev-codemonk-static-content/avatars/voices/voice.river%20-%20SAz9YHcvj6GT2YYXdXww.mp3',
    voice_id: 'SAz9YHcvj6GT2YYXdXww',
    name: 'River',
  },
  {
    gender: 'female',
    url: 'https://storage.googleapis.com/dev-codemonk-static-content/avatars/voices/voice.bella%20-%20hpp4J3VqNfWAUOO0d1Us.mp3',
    voice_id: 'hpp4J3VqNfWAUOO0d1Us',
    name: 'Bella',
  },
  {
    gender: 'male',
    url: 'https://storage.googleapis.com/dev-codemonk-static-content/avatars/voices/voice.roger%20-%20CwhRBWXzGAHq8TQ4Fs17.mp3',
    voice_id: 'CwhRBWXzGAHq8TQ4Fs17',
    name: 'Roger',
  },
  {
    gender: 'male',
    url: 'https://storage.googleapis.com/dev-codemonk-static-content/avatars/voices/voice.liam%20-%20TX3LPaxmHKxFdv7VOQHJ.mp3',
    voice_id: 'TX3LPaxmHKxFdv7VOQHJ',
    name: 'Liam',
  },
] as const;
